<template>
  <div>
    <div class="columns">
      <div class="column">
        <h2 class="subtitle mb-3">Список детей ({{currentFirebase.name}})</h2>
      </div>
    </div>

    <div class="columns">
      <div class="column" style="text-align: end">
        <b-button
          class="ml-3"
          @click="createChild"
          type="is-primary"
          icon-right="plus"
        >Добавить ребёнка</b-button>
      </div>
    </div>

    <!-- ТАБЛИЦА -->
    <b-table
      :data="children"
      class="users-table"
    >
      <b-table-column label="Родитель" v-slot="props">
        <span>{{ props.row.parent.firebase.id }}. {{ props.row.parent.firebase.name }} →
          {{props.row.parent.name}}</span>
      </b-table-column>

      <b-table-column label="Ребёнок" v-slot="props">
        <span>{{ props.row.child.firebase.id }}. {{ props.row.child.firebase.name }} →
        {{props.row.child.name}}</span>
      </b-table-column>

      <b-table-column label="Действия" v-slot="props">

        <div>
          <b-tooltip label="Редактировать">
            <b-button class="edit_icon" @click="updateChild(props.row)">
              <svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 20h4l10.5 -10.5a1.5 1.5 0 0 0 -4 -4l-10.5 10.5v4"></path>
                <path d="M13.5 6.5l4 4"></path>
              </svg>
            </b-button>
          </b-tooltip>

          <b-tooltip label="Удалить">
            <b-button
              @click="deleteChild(props.row)"
              class="delete_icon">
              <svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 7l16 0"></path>
                <path d="M10 11l0 6"></path>
                <path d="M14 11l0 6"></path>
                <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"></path>
                <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"></path>
              </svg>
            </b-button>
          </b-tooltip>
        </div>

      </b-table-column>
    </b-table>

    <OverlayLoader :show="isLoading"></OverlayLoader>
    <ChildConfirmDeleteModal/>
    <ChildDetailsModal/>

  </div>
</template>

<script>
import OverlayLoader from "@/app/shared/components/app-loader/Loader";
import ChildConfirmDeleteModal
  from '@/app/client/collections_settings/children/shared/modals/confirmDeletionChildModal.vue';
import ChildDetailsModal
  from '@/app/client/collections_settings/children/shared/modals/childDetailsModal.vue';

export default {
  name: "ChildrenList",
  components: {
    OverlayLoader,
    ChildConfirmDeleteModal,
    ChildDetailsModal,
  },
  data() {
    return {
    };
  },
  created() {
    this.getChildren();
    this.getCurrentFirebase();
  },
  computed: {
    currentFirebase() {
      return this.$store.getters.GET_CURRENT_FIREBASE ? this.$store.getters.GET_CURRENT_FIREBASE : null;
    },
    children() {
      return this.$store.getters.GET_CHILDREN;
    },
    isLoading: {
      get() {
        return this.$store.getters.IS_CHILDREN_LOADING;
      },
      set(value) {
        this.$store.commit("SET_CHILDREN_LOADING", value);
      },
    },
    detailOpened: {
      get() {
        return this.$store.getters.IS_DETAIL_CHILD_MODAL;
      },
      set(value) {
        this.$store.commit("SET_DETAIL_CHILD_MODAL", value);
      },
    },
    idFirebase() {
      return this.$route.params.idFirebase;
    },
  },
  methods: {
    getCurrentFirebase() {
      this.$store.dispatch("GET_FIREBASE_BY_ID", this.idFirebase).then(() => {
      }).catch(() => {
        this.$toast.error("Ошибка при получении данных");
      });
    },
    getChildren() {
      this.$store.dispatch("GET_CHILDREN", this.idFirebase).catch(() => {
        this.$toast.error("Ошибка при получении данных");
      });
    },
    deleteChild(child) {
      this.$store.commit('SET_CHILD_DELETION_ID', child.id);
      this.$store.commit('SET_CONFIRM_DELETION_CHILD_MODAL', true);
    },
    createChild() {
      this.$store.commit('SET_DEFAULT_CURRENT_CHILD');
      this.detailOpened = true;
    },
    updateChild(child) {
      this.detailOpened = true;
      this.$store.commit('SET_CURRENT_CHILD', child);
    },
  },
};
</script>

<style>
.draggable-item {
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 10px;
  background-color: #fff;
}
</style>
